module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content nc-page"
  }, [_c('div', {
    staticClass: "nc-surface nd-scope"
  }, [_c('div', {
    staticClass: "nd-scope-field"
  }, [_c('label', {
    attrs: {
      "for": "nd-customer"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('nv-select', {
    staticClass: "nc-input",
    attrs: {
      "id": "nd-customer"
    },
    on: {
      "change": _vm.reload
    },
    model: {
      value: (_vm.customerId),
      callback: function($$v) {
        _vm.customerId = $$v
      },
      expression: "customerId"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All customers")]), _vm._v(" "), _vm._l((_vm.customers), function(client) {
    return _c('option', {
      key: client.id,
      domProps: {
        "value": client.id
      }
    }, [_vm._v(_vm._s(client.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "nd-scope-field"
  }, [_c('label', {
    attrs: {
      "for": "nd-journey"
    }
  }, [_vm._v("Journey")]), _vm._v(" "), _c('nv-select', {
    staticClass: "nc-input",
    attrs: {
      "id": "nd-journey"
    },
    on: {
      "change": _vm.reload
    },
    model: {
      value: (_vm.journeyId),
      callback: function($$v) {
        _vm.journeyId = $$v
      },
      expression: "journeyId"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All journeys")]), _vm._v(" "), _vm._l((_vm.journeys), function(journey) {
    return _c('option', {
      key: journey.id,
      domProps: {
        "value": journey.id
      }
    }, [_vm._v(_vm._s(journey.name))])
  })], 2)], 1), _vm._v(" "), (_vm.scopeActive) ? _c('span', {
    staticClass: "nd-scope-note"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Scoping every tab, count and card below.\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nc-toolbar"
  }, [_c('div', {
    staticClass: "nc-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      staticClass: "nc-tab",
      class: {
        'is-active': _vm.activeTab === tab.key
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(tab.key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.label) + "\n          "), _c('span', {
      staticClass: "nc-tab-count"
    }, [_vm._v(_vm._s(_vm.tabCounts[tab.key]))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "nd-toolbar-right"
  }, [_c('div', {
    staticClass: "nc-tabs nd-view-switch",
    attrs: {
      "role": "group",
      "aria-label": "View"
    }
  }, [_c('button', {
    staticClass: "nc-tab",
    class: {
      'is-active': _vm.viewMode === 'list'
    },
    attrs: {
      "title": "List view"
    },
    on: {
      "click": function($event) {
        return _vm.setViewMode('list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" List")]), _vm._v(" "), _c('button', {
    staticClass: "nc-tab",
    class: {
      'is-active': _vm.viewMode === 'box'
    },
    attrs: {
      "title": "Box view"
    },
    on: {
      "click": function($event) {
        return _vm.setViewMode('box')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" Box")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nc-btn nc-btn-primary",
    attrs: {
      "to": "/nudge-console/create-campaign"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Create Campaign\n        ")])], 1)]), _vm._v(" "), (!_vm.showingDrafts) ? _c('div', {
    staticClass: "nc-surface nc-filters"
  }, [_c('div', {
    staticClass: "nc-field nc-field-grow"
  }, [_c('label', {
    attrs: {
      "for": "nd-search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "nc-input",
    attrs: {
      "id": "nd-search",
      "type": "text",
      "placeholder": "Campaign name — press Enter"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reload.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nc-field"
  }, [_c('label', {
    attrs: {
      "for": "nd-type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "nc-input",
    attrs: {
      "id": "nd-type"
    },
    on: {
      "change": _vm.reload
    },
    model: {
      value: (_vm.campaignType),
      callback: function($$v) {
        _vm.campaignType = $$v
      },
      expression: "campaignType"
    }
  }, _vm._l((_vm.campaignTypeOptions), function(option) {
    return _c('option', {
      key: option.label,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n          ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "nc-field"
  }, [_c('label', {
    attrs: {
      "for": "nd-from"
    }
  }, [_vm._v("Created from")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDt),
      expression: "fromDt"
    }],
    staticClass: "nc-input",
    attrs: {
      "id": "nd-from",
      "type": "date"
    },
    domProps: {
      "value": (_vm.fromDt)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nc-field"
  }, [_c('label', {
    attrs: {
      "for": "nd-to"
    }
  }, [_vm._v("Created to")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDt),
      expression: "toDt"
    }],
    staticClass: "nc-input",
    attrs: {
      "id": "nd-to",
      "type": "date"
    },
    domProps: {
      "value": (_vm.toDt)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDt = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.hasFilters) ? _c('button', {
    staticClass: "nc-btn nc-btn-ghost",
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("Clear")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showingDrafts) ? _c('div', [(!_vm.loading && !_vm.drafts.length) ? _c('div', {
    staticClass: "nc-surface nc-empty"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-title"
  }, [_vm._v("No drafts in progress")]), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-text"
  }, [_vm._v("\n          The chats auto-save every 60 seconds, so an unfinished campaign or template shows up here.\n          "), _c('router-link', {
    attrs: {
      "to": "/nudge-console/create-campaign"
    }
  }, [_vm._v("Start a campaign")]), _vm._v(" or\n          "), _c('router-link', {
    attrs: {
      "to": "/nudge-template/ai-create"
    }
  }, [_vm._v("create a template")]), _vm._v(".\n        ")], 1)]) : (_vm.isList) ? _c('div', {
    staticClass: "nc-surface nd-table-wrap"
  }, [_c('table', {
    staticClass: "nd-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.drafts), function(draft) {
    return _c('tr', {
      key: draft.id
    }, [_c('td', [_c('span', {
      staticClass: "nd-cell-name"
    }, [_vm._v(_vm._s(_vm.draftName(draft)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.draftType(draft)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.draftJourney(draft)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.draftStep(draft)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.draftEdited(draft)))]), _vm._v(" "), _c('td', {
      staticClass: "nd-col-actions"
    }, [_c('div', {
      staticClass: "nd-row-actions"
    }, [_c('router-link', {
      staticClass: "nc-btn nc-btn-sm nc-btn-ghost",
      attrs: {
        "to": _vm.draftResumeLink(draft)
      }
    }, [_vm._v("\n                    Resume →\n                  ")]), _vm._v(" "), _c('button', {
      staticClass: "nc-btn nc-btn-sm nc-btn-danger",
      attrs: {
        "title": "Discard draft"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDiscardDraft(draft)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])], 1)])])
  }), 0)])]) : _c('div', {
    staticClass: "nd-cards"
  }, _vm._l((_vm.drafts), function(draft) {
    return _c('div', {
      key: draft.id,
      staticClass: "nc-surface nd-card"
    }, [_c('div', {
      staticClass: "nd-card-head"
    }, [_c('div', [_c('div', {
      staticClass: "nd-card-name"
    }, [_vm._v(_vm._s(_vm.draftName(draft)))]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-meta"
    }, [_vm._v(_vm._s(_vm.draftStep(draft)))])]), _vm._v(" "), _c('span', {
      staticClass: "nc-badge",
      class: _vm.isTemplateChat(draft) ? 'nc-badge-teal' : 'nc-badge-warning'
    }, [_vm._v(_vm._s(_vm.isTemplateChat(draft) ? 'Template draft' : 'Campaign draft'))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-rows"
    }, [_c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Nudge type")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.draftType(draft)))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Journey")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.draftJourney(draft)))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Last edited")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.draftEdited(draft)))])])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-actions"
    }, [_c('router-link', {
      staticClass: "nc-btn nc-btn-sm nc-btn-primary",
      attrs: {
        "to": _vm.draftResumeLink(draft)
      }
    }, [_vm._v("\n              Resume →\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "nd-spacer"
    }), _vm._v(" "), _c('button', {
      staticClass: "nc-btn nc-btn-sm nc-btn-danger",
      attrs: {
        "title": "Discard draft"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDiscardDraft(draft)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])], 1)])
  }), 0)]) : [(!_vm.loading && !_vm.campaigns.length) ? _c('div', {
    staticClass: "nc-surface nc-empty"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-title"
  }, [_vm._v("No " + _vm._s(_vm.activeTabLabel) + "campaigns to show")]), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-text"
  }, [_vm._v("\n          Nothing matches the current scope and filters.\n          "), _c('router-link', {
    attrs: {
      "to": "/nudge-console/create-campaign"
    }
  }, [_vm._v("Create a campaign")]), _vm._v("\n          to get started.\n        ")], 1)]) : (_vm.isList) ? _c('div', {
    staticClass: "nc-surface nd-table-wrap"
  }, [_c('table', {
    staticClass: "nd-table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.campaigns), function(campaign) {
    return _c('tr', {
      key: campaign.id,
      class: {
        'nd-row-highlight': _vm.isHighlighted(campaign)
      }
    }, [_c('td', [_c('span', {
      staticClass: "nd-cell-name"
    }, [_vm._v(_vm._s(campaign.opportunity_name))]), _vm._v(" "), _c('span', {
      staticClass: "nd-cell-sub"
    }, [_vm._v("\n                  " + _vm._s(campaign.country_name || '—') + " · " + _vm._s(campaign.customer_name || 'No customer') + "\n                ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "nd-type",
      class: _vm.campaignTypeOf(campaign).className
    }, [_c('i', {
      class: _vm.campaignTypeOf(campaign).icon
    }), _vm._v("\n                  " + _vm._s(_vm.campaignTypeOf(campaign).label) + "\n                ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "nc-badge",
      class: _vm.statusBadgeClass(campaign),
      attrs: {
        "title": _vm.statusTitle(campaign)
      }
    }, [_vm._v(_vm._s(_vm.statusLabel(campaign)))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "nc-badge",
      class: _vm.sourceBadgeClass(campaign)
    }, [_vm._v(_vm._s(_vm.sourceLabel(campaign)))])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.triggerText(campaign)) + "\n                "), _c('span', {
      staticClass: "nd-cell-sub"
    }, [_vm._v(_vm._s(_vm.sessionText(campaign)))])]), _vm._v(" "), _c('td', {
      staticClass: "nd-col-num"
    }, [_vm._v(_vm._s(_vm.firesText(campaign)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lastFiredText(campaign)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.createdText(campaign)))]), _vm._v(" "), _c('td', {
      staticClass: "nd-col-actions"
    }, [_c('div', {
      staticClass: "nd-row-actions"
    }, [(!_vm.showingDeleted && _vm.statusAction(campaign)) ? _c('label', {
      staticClass: "nd-toggle",
      attrs: {
        "title": _vm.statusAction(campaign).label + ' this campaign'
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": campaign.opportunity_status === _vm.activeStatus
      },
      on: {
        "change": function($event) {
          return _vm.confirmStatusChange(campaign)
        }
      }
    }), _vm._v(" "), _vm._m(5, true)]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
      attrs: {
        "title": "View analytics",
        "to": {
          path: '/nudge-console/analytics',
          query: {
            campaignId: campaign.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bar-chart"
    })]), _vm._v(" "), (!_vm.showingDeleted) ? _c('router-link', {
      staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
      attrs: {
        "title": "Edit campaign",
        "to": {
          path: '/nudge-console/edit-campaign',
          query: {
            campaignId: campaign.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (!_vm.showingDeleted && !campaign.is_in_session && campaign.group_list && campaign.group_list.length) ? _c('button', {
      staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
      attrs: {
        "title": "Send test"
      },
      on: {
        "click": function($event) {
          return _vm.testNudgeClick(campaign)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]) : _vm._e(), _vm._v(" "), (!_vm.showingDeleted) ? _c('button', {
      staticClass: "nc-btn nc-btn-sm nc-btn-danger",
      attrs: {
        "title": "Delete campaign"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDelete(campaign)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()], 1)])])
  }), 0)])]) : _c('div', {
    staticClass: "nd-cards"
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('div', {
      key: campaign.id,
      staticClass: "nc-surface nd-card",
      class: {
        'nd-row-highlight': _vm.isHighlighted(campaign)
      }
    }, [_c('div', {
      staticClass: "nd-card-head"
    }, [_c('div', [_c('div', {
      staticClass: "nd-card-name"
    }, [_vm._v(_vm._s(campaign.opportunity_name))]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-meta"
    }, [_vm._v("\n                " + _vm._s(campaign.country_name || '—') + " · " + _vm._s(campaign.customer_name || 'No customer') + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-badges"
    }, [_c('span', {
      staticClass: "nc-badge",
      class: _vm.statusBadgeClass(campaign),
      attrs: {
        "title": _vm.statusTitle(campaign)
      }
    }, [_vm._v(_vm._s(_vm.statusLabel(campaign)))]), _vm._v(" "), _c('span', {
      staticClass: "nd-type",
      class: _vm.campaignTypeOf(campaign).className
    }, [_c('i', {
      class: _vm.campaignTypeOf(campaign).icon
    }), _vm._v("\n                " + _vm._s(_vm.campaignTypeOf(campaign).label) + "\n              ")])])]), _vm._v(" "), (_vm.gateOf(campaign) && campaign.template_gate_reason) ? _c('div', {
      staticClass: "nd-card-gate"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }), _vm._v(" " + _vm._s(campaign.template_gate_reason) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "nd-card-rows"
    }, [_c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Nudge Console campaign")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_c('span', {
      staticClass: "nc-badge",
      class: _vm.sourceBadgeClass(campaign)
    }, [_vm._v(_vm._s(_vm.sourceLabel(campaign)))])])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Trigger")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.triggerText(campaign)))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Window")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.sessionText(campaign)))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Content")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.contentText(campaign)))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Fires to date")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.firesText(campaign)))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Last fired")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.lastFiredText(campaign)))])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-row"
    }, [_c('span', {
      staticClass: "nd-card-row-label"
    }, [_vm._v("Created")]), _vm._v(" "), _c('span', {
      staticClass: "nd-card-row-value"
    }, [_vm._v(_vm._s(_vm.createdText(campaign)))])])]), _vm._v(" "), _c('div', {
      staticClass: "nd-card-actions"
    }, [(!_vm.showingDeleted && _vm.statusAction(campaign)) ? _c('label', {
      staticClass: "nd-toggle",
      attrs: {
        "title": _vm.statusAction(campaign).label + ' this campaign'
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": campaign.opportunity_status === _vm.activeStatus
      },
      on: {
        "change": function($event) {
          return _vm.confirmStatusChange(campaign)
        }
      }
    }), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _c('span', {
      staticClass: "nd-toggle-label"
    }, [_vm._v("\n                " + _vm._s(campaign.opportunity_status === _vm.activeStatus ? 'Active' : (_vm.gateOf(campaign) ? _vm.gateOf(campaign).action + '?' : 'Paused')) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
      attrs: {
        "to": {
          path: '/nudge-console/analytics',
          query: {
            campaignId: campaign.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bar-chart"
    }), _vm._v(" Analytics\n            ")]), _vm._v(" "), (!_vm.showingDeleted) ? _c('router-link', {
      staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
      attrs: {
        "to": {
          path: '/nudge-console/edit-campaign',
          query: {
            campaignId: campaign.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "nd-spacer"
    }), _vm._v(" "), (!_vm.showingDeleted && !campaign.is_in_session && campaign.group_list && campaign.group_list.length) ? _c('button', {
      staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
      attrs: {
        "title": "Send test"
      },
      on: {
        "click": function($event) {
          return _vm.testNudgeClick(campaign)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    }), _vm._v(" Send Test\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.showingDeleted) ? _c('button', {
      staticClass: "nc-btn nc-btn-sm nc-btn-danger",
      attrs: {
        "title": "Delete campaign"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDelete(campaign)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()], 1)])
  }), 0), _vm._v(" "), (_vm.pageCount > 1) ? _c('div', {
    staticClass: "nd-pager-wrap"
  }, [_c('span', {
    staticClass: "nd-pager-summary"
  }, [_vm._v(_vm._s(_vm.rangeSummary))]), _vm._v(" "), _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 5,
      "margin-pages": 1,
      "force-page": _vm.page,
      "click-handler": _vm.goToPage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'nc-pagination',
      "page-class": 'nc-pagination-item',
      "page-link-class": 'nc-pagination-link',
      "prev-class": 'nc-pagination-item',
      "next-class": 'nc-pagination-item',
      "prev-link-class": 'nc-pagination-link nc-pagination-nav',
      "next-link-class": 'nc-pagination-link nc-pagination-nav',
      "break-view-class": 'nc-pagination-item nc-pagination-break',
      "break-view-link-class": 'nc-pagination-link',
      "active-class": 'nc-pagination-item-active',
      "disabled-class": 'nc-pagination-item-disabled'
    }
  })], 1) : _vm._e()]], 2), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendTestNudge.apply(null, arguments)
      }
    }
  }, [(_vm.audienceSelectionVisible) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "nudgeConsoleUserSelection"
    }
  }, [_c('div', {
    staticClass: "modal modal-md modal-user-selection"
  }, [_c('div', {
    staticClass: "test-nudge-container"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', {
      staticClass: "control-label modal-label",
      attrs: {
        "for": "search"
      }
    }, [_vm._v("Select Group:")]), _vm._v("\n                    \n                  "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "wrap"
      }
    }, _vm._l((_vm.selectedCampaign.group_list), function(group) {
      return _c('div', {
        key: group.group_name,
        staticStyle: {
          "width": "233px"
        }
      }, [_c('label', {
        staticClass: "radio-inline campaign-group-details",
        class: {
          'reengagement-group-disabled': !group.msg_template_id
        },
        staticStyle: {
          "display": "flex",
          "flex-direction": "column",
          "margin-bottom": "10px",
          "padding-left": "20px"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedGroup),
          expression: "selectedGroup"
        }],
        attrs: {
          "type": "radio",
          "disabled": !group.msg_template_id
        },
        domProps: {
          "value": group,
          "checked": _vm._q(_vm.selectedGroup, group)
        },
        on: {
          "change": function($event) {
            _vm.selectedGroup = group
          }
        }
      }), _vm._v(" "), _c('div', [_vm._v(_vm._s(group.group_name))]), _vm._v(" "), _c('div', [_vm._v("Nudge: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.msg_template_name ? group.msg_template_name : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Split Percent: "), _c('span', {
        staticClass: "campaign-details-text"
      }, [_vm._v(_vm._s(group.split_percent || group.split_percent === 0 ? group.split_percent + '%' : '-'))])])])])
    }), 0), _vm._v(" "), (_vm.submittedTestNudge && !_vm.$v.selectedGroup.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please select a group.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', {
      staticClass: "control-label modal-label",
      attrs: {
        "for": "search"
      }
    }, [_vm._v("Select test user(s):")]), _vm._v(" "), _c('label', {
      staticClass: "hint-text"
    }, [_vm._v("Only onboarded users appear here. To include your account in a test, make sure you're currently onboarded to the correct country.")]), _vm._v("\n                    \n                  "), _c('div', {
      staticClass: "users-checkbox-container"
    }, [_vm._l((_vm.userList), function(user) {
      return _c('div', {
        key: user.account_id
      }, [_c('label', {
        staticClass: "checkbox-inline col-xs-6 col-sm-6 col-md-5 col-lg-4"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedUsers),
          expression: "selectedUsers"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": user,
          "checked": Array.isArray(_vm.selectedUsers) ? _vm._i(_vm.selectedUsers, user) > -1 : (_vm.selectedUsers)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedUsers,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = user,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedUsers = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedUsers = $$c
            }
          }
        }
      }), _vm._v(_vm._s(user.account_name) + "\n                      ")])])
    }), _vm._v(" "), (!_vm.userList.length) ? _c('div', [_vm._v("There are no users ")]) : _vm._e()], 2), _vm._v(" "), (_vm.submittedTestNudge && !_vm.$v.selectedUsers.required) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("Please select users to send message.")]) : _vm._e()])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAudienceSelection
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send Test")])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Nudge Console")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Dashboard")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nc-empty-icon"
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Draft")]), _vm._v(" "), _c('th', [_vm._v("Nudge type")]), _vm._v(" "), _c('th', [_vm._v("Journey")]), _vm._v(" "), _c('th', [_vm._v("Step")]), _vm._v(" "), _c('th', [_vm._v("Last edited")]), _vm._v(" "), _c('th', {
    staticClass: "nd-col-actions"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nc-empty-icon"
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Campaign")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Nudge Console")]), _vm._v(" "), _c('th', [_vm._v("Trigger")]), _vm._v(" "), _c('th', {
    staticClass: "nd-col-num"
  }, [_vm._v("Fires")]), _vm._v(" "), _c('th', [_vm._v("Last fired")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th', {
    staticClass: "nd-col-actions"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-toggle-track"
  }, [_c('span', {
    staticClass: "nd-toggle-knob"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-toggle-track"
  }, [_c('span', {
    staticClass: "nd-toggle-knob"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2b53520a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/NudgeDashboard.vue
// module id = w0iz
// module chunks = 1